import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Tutor",
      desc: "As a seasoned Computer Science Tutor, I specialize in guiding students through the fascinating realm of programming, data structures and algorithms, software engineering principles, database management, web development, and more. With years of experience in both academia and industry, I bring a wealth of knowledge to every session",
      icon: "fa fa-graduation-cap",
    },
    {
      name: "Front-End Development",
      desc: "Craft visually appealing, responsive, and user-friendly interfaces. Leverage the power of core web technologies to create dynamic and interactive user experiences. Build robust front-end applications with popular frameworks (React), ensuring high performance and scalability.",
      icon: "fa fa-desktop",
    },
    {
      name: "UI/UX Design",
      desc: "Apply best practices in user interface and user experience design to enhance usability and accessibility.",
      icon: "fa fa-pencil",
    },
    {
      name: "Comprehensive Development Skills",
      desc: "Utilize version control systems to track changes, collaborate with team members, and maintain codebase integrity. Implement continuous integration and deployment pipelines, automate testing and deployment processes, and ensure smooth application delivery. Work collaboratively in Agile environments, participate in sprint planning, and adapt quickly to changing project requirements.",
      icon: "fa fa-code",
    },
    {
      name: "Back-End Development",
      desc: "Develop server-side logic and APIs to handle data processing, authentication, and business logic.  Design and optimize database schemas, perform CRUD operations, and ensure data integrity for efficient storage and retrieval. Integrate third-party APIs and services to extend functionality and streamline workflows within applications. Implement secure authentication and authorization mechanisms to safeguard user data and protect against unauthorized access.",
      icon: "fa fa-server",
    },
    {
      name: "Gaming",
      desc: "I like to relax and play games in my free time. I would consider myself a variety gamer as I dabble in all genres. You can check out some of my gaming clips <a href='https://www.tiktok.com/@trays.gaming.clip' target='_blank'>here</a>.",
      icon: "fa fa-gamepad",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        <h5 className="fw-400 text-center mb-5 wow fadeInUp">
          I am passionate about problem solving and finding new ways to solve existing problems.
        </h5>
        
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: service.desc }} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
